var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"counter"},[_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.count))]),_c('div',{staticClass:"info"},[_vm._v("Accesări")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }